"use client";

/**
 * The single client-provider stack, mounted once by `RootDocument` (which every
 * root layout renders): token provider + session-keyed query/tRPC clients (the
 * auth boundary), with the analytics lifecycle inside the boundary so its
 * queries are identity-scoped. Pure children-pass-through — no dynamic APIs —
 * so statically rendered routes (the marketing page) stay static.
 */
import type { ReactNode } from "react";

import { AnalyticsLifecycle } from "../lib/analytics/lifecycle";
import { AuthSessionBoundary } from "../lib/trpc/provider";

/**
 * Wrap the page in the auth boundary and mount the analytics lifecycle inside it.
 *
 * @param props.children - the route's rendered tree.
 * @returns the provider stack around `children`.
 */
export function Providers({ children }: { children: ReactNode }): React.JSX.Element {
  return (
    <AuthSessionBoundary>
      <AnalyticsLifecycle />
      {children}
    </AuthSessionBoundary>
  );
}
